import { render } from "./AdminExamDetailView.vue?vue&type=template&id=4185615b&scoped=true"
import script from "./AdminExamDetailView.vue?vue&type=script&lang=js"
export * from "./AdminExamDetailView.vue?vue&type=script&lang=js"

import "./AdminExamDetailView.vue?vue&type=style&index=0&id=4185615b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4185615b"]])

export default __exports__